import { AccessibilityInfo as AccessibilityInfoRN } from 'react-native-web';

// registers the media query with the browser
const reducedMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');

const AccessibilityInfo = {
  isReduceMotionEnabled: (): boolean => (
    reducedMotionQuery?.matches
  ),
  // isReduceMotionEnabled is part of newer versions of react-native-web
  // which we can't upgrade to yet.
  ...AccessibilityInfoRN,
};

export default AccessibilityInfo;
